import React from 'react'
import {Input } from 'reactstrap';

class TownsSelect extends React.Component{
  constructor(props) {
    super(props);
//    this.state = {      
//      towns: props.towns,            
//      onChange: props.onChange,
//    };

    //this.handleInputChange = this.handleInputChange.bind(this);    
    this.handleChange = this.handleChange.bind(this);
  }
//  handleInputChange(event) {
//    const target = event.target;
//    const value = target.type === 'checkbox' ? target.checked : target.value;
//    const name = target.name;
//
//    this.setState({
//      [name]: value
//    });
//    //console.log(name + ' -> ' + value);
//  }
  
  handleChange(event) {
    return this.props.onChange(event);
    //this.setState({value: event.target.value});
  }
  
  render() {
    return (
      <Input type="select"
        value={this.props.value} 
        onChange={this.handleChange} 
        name={this.props.name}
      >    
        {this.props.towns.map(pos => (
          <option key={pos} value={pos}>{pos}</option>            
        ))}        
      </Input>
    )
  }
}
    
export default TownsSelect;


// WEBPACK FOOTER //
// ./src/components/TownsSelect.js